module.exports = {
  filterFields,
  isFlagEnabled,
  isUserAllowed
}

function isFlagEnabled(featureFlagRecord, flagName) {
  const flag = getFlagValue(featureFlagRecord, flagName)
  return flag === true
}

function isUserAllowed(featureFlagRecord, flagName, userId) {
  const flag = getFlagValue(featureFlagRecord, flagName) || []

  if (flag === true || flag === false) {
    return flag
  }

  return (flag.includes(true) || flag.includes(userId)) && !flag.includes(false)
}

function filterFields(featureFlagRecord, flagName, object) {
  const fieldsToDelete = getFlagValue(featureFlagRecord, flagName) || []

  fieldsToDelete.forEach((fieldName) => {
    deleteField(object, fieldName)
  })
}

function deleteField(object, fieldName) {
  if (!object) {
    return
  }

  if (fieldName.includes('.')) {
    const fields = fieldName.split('.')
    const objectField = fields.shift()
    deleteField(object[objectField], fields.join('.'))
  } else {
    delete object[fieldName]
  }
}

function getFlagValue(featureFlagRecord, flagName) {
  const {
    Data: {
      [flagName]: flag
    } = {}
  } = featureFlagRecord || {}

  return flag
}